export default __webpack_public_path__ + "static/media/main.a3cc27ee.png";